// Module
var code = "<template><require from=\"../../../../components/data-grid/data-grid\"></require><div class=\"padding-10 animation-slide-bottom\"><data-grid class=\"scrollable-content\" item-source.bind=\"itemSource\" sorting-enabled.bind=\"true\" filtering-enabled.bind=\"true\" paging-enabled.bind=\"true\"></data-grid></div></template>";
// Exports
module.exports = code;